/*
 | Botones magnéticos.
 |
 | Los elementos `.magnet` se desplazan levemente hacia el cursor y vuelven a su
 | sitio al salir. Solo con puntero fino (nada en táctil) y respetando
 | prefers-reduced-motion. Delegado en document, igual que el spotlight.
 */
const SELECTOR = ".magnet";
const STRENGTH_X = 0.18;
const STRENGTH_Y = 0.22;

export default function registerMagnet() {
    if (!window.matchMedia("(hover: hover)").matches) {
        return;
    }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
    }

    document.addEventListener(
        "mousemove",
        (event) => {
            const target = event.target instanceof Element ? event.target.closest(SELECTOR) : null;

            if (!target) {
                return;
            }

            const rect = target.getBoundingClientRect();
            const x = (event.clientX - rect.left - rect.width / 2) * STRENGTH_X;
            const y = (event.clientY - rect.top - rect.height / 2) * STRENGTH_Y;

            target.style.transform = `translate(${x}px, ${y}px)`;
        },
        { passive: true },
    );

    // mouseleave no burbujea: usamos mouseout y descartamos los saltos internos.
    document.addEventListener(
        "mouseout",
        (event) => {
            const target = event.target instanceof Element ? event.target.closest(SELECTOR) : null;

            if (!target) {
                return;
            }

            if (event.relatedTarget instanceof Node && target.contains(event.relatedTarget)) {
                return;
            }

            target.style.transform = "";
        },
        { passive: true },
    );
}
